import * as React from "react";
const SvgSpeakerOff20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "m17 4.414 2.707-2.707L18.293.293l-18 18 1.414 1.414L6.914 14.5h.824l7.772 4.372 1.49.838V4.414Zm-2 2-6 6v.501l6 3.375V6.414ZM7.738 5.5l6.036-3.395L7 8.879V7.5H4v4.379l-2 2V5.5h5.738Z",
      clipRule: "evenodd"
    })
  );
export default SvgSpeakerOff20Px;
